import React from 'react';
import AppointmentShortList from '../AppointmentShortList/AppointmentShortList';
const AppointmentByDate = ({appointments, date}) => {

    return (
        <div className='shadow-sm bg-white p-4 mt-5'>
            <div className='d-flex justify-content-between'>
                <h6 className='head-color fw-bold'>Appointments </h6>
                <p className='text-muted'>{date.toDateString()}</p>
            </div>
            {
                appointments.length ?
                <AppointmentShortList appointments={appointments}></AppointmentShortList> 
                :
                <p className='text-center py-5 fs-5'>No Appointment for this date</p>

            }
            
        </div>
    );
};

export default AppointmentByDate;